const ABILITY_TAGS = ['---', 'STR', 'DEX', 'CON', 'INT', 'WIS', 'CHA'];
export default ABILITY_TAGS;
